import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let tx = useDataValue({
    context: 'profile_patient_tx',
    viewPath: props.viewPath,
  })
  return {
    variables: {
      parent_company_id: tx.organization?.parent_company[0]?.id,
      type: tx.status,
    },
  }
}
